export default {
    userInfo: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        currency: window.constants.currencies.USD,
        country: 'US',
        state: '',
        company: '',
        line1: '',
        line2: '',
        city: '',
        postalCode: '',
        paymentToken: '',
        subscriptionId: '',
        customerId: '',
        tenantId: '',
    },
    purchaseInfo: {
        planEdition: null,
        partnerAccountId: '',
        linkId: '',
        eventId: '',
        quoteId: '',
        linkPostedBy: '',
        bundleId: '',
        bundleDetails: {},
        sourceCode: '',
        partnerName: '',
        purchaseLinkId: '',
        customerId: '',
        subscriptionId: '',
        channel: '',
        showEtf: false,
        showTc: false,
        showMbg90: false,
        billingToggle: false,
        isInfluencer: false,
        contacts: 0,
        users: 0,
        additionalMessages: null,
        textVoiceTier: null,
        kickstartId: '',
        token: '',
        totalPaid: 0,
        invoiceTotal: 0,
        isSelfUpgrading: false,
        isUpgrading: false,
        isAddingSub: false,
        cardUsed: {
            last4: '',
            type: '',
        },
        thryvCrossSell: {
            eaid: null,
            salesRep: null,
            businessAdvisorId: null,
        }
    },
    cartInfo: {
        pricing: [],
        coupons: [],
        selectedBillingPeriod: '1 year',
        billingPeriod: 'year',
        selectedPlanId: '',
        selectedAddons: [],
        selectedCharges: [],
        acceptedTc: false,
        acceptedMbg90: false,
        acceptedInstallments: false,
        originalQuantities: [],
        tempStorage: {
            attachments: []
        },
        installments: {
            count: 0, // numberOfInstallments (cf_number_of_installments)
            enabled: false, // applyInstallments (cf_apply_installments)

        },
        flags: [],
    },
    estimate: {},
    talon: '{\'version\': 6, \'status\': -1}',
    orderStatus: {
        submitting: false,
        submittingContactSales: false,
        success: false,
        contactedSales: false,
    },
    canSubmit: false,
    error: {
        active: false,
        title: '',
        message: '',
        code: 0,
        sentryId: '',
    },
    linkError: {
        active: false,
        message: '',
        code: 0,
    },
    validation: {
        company: {
            valid: false,
            message: '',
        },
        line1: {
            valid: false,
            message: '',
        },
        city: {
            valid: false,
            message: '',
        },
        state: {
            valid: false,
            message: '',
        },
        country: {
            valid: true,
            message: '',
        },
        postalCode: {
            valid: false,
            message: '',
        },
        firstName: {
            valid: false,
            message: '',
        },
        lastName: {
            valid: false,
            message: '',
        },
        phone: {
            valid: false,
            message: '',
        },
        email: {
            valid: false,
            message: '',
        },
        cardNumber: {
            valid: false,
            message: '',
        },
        cardExpire: {
            valid: false,
            message: '',
        },
        cardCvv: {
            valid: false,
            message: '',
        },
        tcAgreement: {
            valid: false,
            message: '',
        },
        mbg90Agreement: {
            valid: false,
            message: '',
        }
    },
    currentStep: 0,
    hasFetchedEstimate: false,
    initialLoading: false,
    softLoading: false,
    loaded: false,
    tracking: {},
    transactionId: '',
};
